module.exports = __webpack_public_path__ + "images/marketing/peeps/christopher_yudichak.png";